import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {},
    components: {
        SunbathingOrderView: {
            component: 'Card',
            title: '晒单管理',
            content: {
                component: 'SunbathingOrder',
            },
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/content',
                    breadcrumbName: '内容管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/sunbathingOrder',
                            component: 'Viewport',
                            breadcrumbName: '晒单管理',
                            childRoutes: [
                                {
                                    path: '/edit/:id',
                                    component: 'SunbathingEdit',
                                    breadcrumbName: '编辑晒单',
                                },
                                {
                                    path: '/detail/:id',
                                    component: 'SunbathingDetail',
                                    breadcrumbName: '晒单详情',
                                },
                                {
                                    path: '/',
                                    component: 'SunbathingOrderView',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
